:host {
  @include reset-host;

  picture {
    display: block;
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
  }

  img {
    display: block;
    max-width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

:host(.cover) {
  @include cover;

  img {
    @include cover;
  }
}
